
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Onewaycabservicemumbaitopunedrop() {



    const cardData =
    {
        keyword: 'One Way Cab Services Mumbai to Pune Drop',
        heading: 'etravo : One Way Cab Services Mumbai to Pune Drop ',
        headingDescription: 'eTravo offers professional One Way Cab Services from Mumbai to Pune, ideal for corporate drop requirements and intercity travel. Whether it’s an executive returning from a business meeting or a client drop-off after a corporate event, our one-way cab service ensures a smooth, safe, and timely ride. With a fleet of clean, GPS-enabled vehicles driven by trained chauffeurs, we prioritize punctuality, comfort, and professionalism. Choose eTravo for efficient and hassle-free one-way drop services from Mumbai to Pune — trusted by businesses for reliable intercity transport.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire. Though much of the fort was destroyed by fire in 1828, the remaining structures, including the massive gates and foundations, offer a glimpse into its majestic past. The site is known for its architectural grandeur and the evening light and sound show that narrates its rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892, the Aga Khan Palace is a significant monument in Indian history. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace is renowned for its Italian arches, sprawling lawns, and the memorials of Gandhi and Kasturba. It now houses a museum dedicated to Gandhi's life and work."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill about 30 km from Pune, Sinhagad Fort is a popular trekking destination. The fort has witnessed several battles, including the famous Battle of Sinhagad in 1670. Visitors can explore the ruins, enjoy panoramic views of the surrounding region, and savor local delicacies like 'pithla bhakri' sold by vendors at the summit."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This temple is one of the most famous Ganesh temples in India. Known for its rich history and the grand Ganesh Festival celebrations, the temple attracts thousands of devotees and tourists annually."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a tranquil haven for those seeking peace and spiritual growth. The ashram offers various meditation programs and workshops in a lush, serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of over 20,000 artifacts, showcasing the everyday life of Indians in the past. From musical instruments and paintings to household items and sculptures, the museum offers a deep dive into India's rich cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features intricate carvings and a unique circular Nandi mandapa. It's a serene spot amidst the bustling city."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill is one of the highest points in Pune, offering a panoramic view of the city. Atop the hill stands the Parvati Temple, dedicated to Goddess Parvati. The hill is a popular spot for morning walks and photography enthusiasts."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as Pu La Deshpande Garden, this is one of the largest Japanese-style gardens outside Japan. Inspired by the 300-year-old Okayama Korakuen Garden, it features manicured lawns, flowing streams, and picturesque bridges."
    },
    {
      "title": "Empress Garden",
      "description": "Spread over 39 acres, Empress Garden is a botanical garden known for its lush greenery, rare flora, and well-maintained lawns. It's a perfect spot for picnics, leisurely walks, and enjoying nature in the heart of the city."
    }
  ],
 "services": [
    {
      "name": "Corporate One-Way Cab Mumbai to Pune",
      "description": "eTravo offers efficient corporate one-way cab services from Mumbai to Pune, designed for business travelers seeking hassle-free and timely transportation. Our fleet of well-maintained, air-conditioned vehicles ensures a comfortable journey, allowing you to focus on your work while we handle your travel logistics."
    },
    {
      "name": "Executive Car Drop from Mumbai to Pune",
      "description": "Experience premium executive car drop services with eTravo, tailored for corporate clients traveling from Mumbai to Pune. Our luxury vehicles and professional chauffeurs provide a seamless and stress-free travel experience, ensuring punctual arrivals at your destination for meetings, conferences, or business engagements."
    },
    {
      "name": "Affordable Business Travel Cabs Mumbai to Pune",
      "description": "Travel smart with eTravo’s affordable business travel cab options from Mumbai to Pune. We combine cost-effective pricing with high standards of service and vehicle quality, making corporate travel economical without compromising on comfort or reliability."
    },
    {
      "name": "AC Cab Service for Corporate Drops Mumbai to Pune",
      "description": "Stay cool and comfortable during your Mumbai to Pune corporate drop with eTravo’s air-conditioned cab services. Our cabs are equipped to provide a smooth and relaxing ride, perfect for busy professionals who value comfort and efficiency."
    },
    {
      "name": "Safe & Reliable One-Way Taxi for Corporate Travelers",
      "description": "eTravo prioritizes safety and reliability with its one-way taxi services from Mumbai to Pune for corporate travelers. Our experienced drivers follow all safety protocols, ensuring a secure journey and on-time arrival for all your business travel needs."
    },
    {
      "name": "Mumbai to Pune Drop Cab for Business Clients",
      "description": "Designed specifically for business clients, eTravo’s drop cab service from Mumbai to Pune guarantees professional service, punctuality, and comfort. Whether it’s airport transfers or intercity meetings, we ensure your travel is smooth and stress-free."
    }
  ],
  "tableData": [
    ["Corporate One-Way Cab Mumbai to Pune", "Executive Car Drop from Mumbai to Pune"],
    ["Affordable Business Travel Cabs Mumbai to Pune", "AC Cab Service for Corporate Drops Mumbai to Pune"],
    ["Safe & Reliable One-Way Taxi for Corporate Travelers", "Mumbai to Pune Drop Cab for Business Clients"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Affordable One-Way Cab from Mumbai to Pune",
        "WhyChoosedescription": "eTravo offers convenient and cost-effective one-way cab services from Mumbai to Pune. Whether you're heading to a business meeting, college campus, or family home, our service allows you to pay only for the drop—no return fare, no hidden charges."
    },
    {
        "WhyChooseheading": "Clean, Comfortable & Well-Maintained Cabs",
        "WhyChoosedescription": "Travel in comfort with our wide range of vehicles—sedans, SUVs, and premium cars. All cabs are air-conditioned, sanitized, and thoroughly inspected before every trip. With spacious seating and ample luggage space, your journey between Mumbai and Pune will be smooth and hassle-free."
    },
    {
        "WhyChooseheading": "Professional Drivers with Intercity Expertise",
        "WhyChoosedescription": "Our drivers are trained for long-distance travel and familiar with the Mumbai–Pune Expressway. They follow safe driving practices, know the best pit stops, and are courteous and punctual—ensuring a stress-free experience from pickup to drop."
    },
    {
        "WhyChooseheading": "Flexible Pickup Options Across Mumbai",
        "WhyChoosedescription": "Whether you're departing from the airport, a railway station, a hotel, or your home in South Mumbai or the suburbs, eTravo offers door-to-door pickup and drop services. Just book your cab, and we’ll handle the rest—no need to find or negotiate with local taxis."
    },
    {
        "WhyChooseheading": "24/7 Booking and Emergency Support",
        "WhyChoosedescription": "Travel plans can change anytime, and we’re here to help around the clock. Our customer support team is available 24/7 for bookings, changes, or last-minute assistance. We also offer live ride tracking and instant driver details before your journey begins."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "At eTravo, what you see is what you pay. Our one-way cab fares from Mumbai to Pune include tolls, driver allowance, and fuel—no surprises at the end of the ride. Get an upfront fare estimate and travel confidently with full pricing transparency."
    },
    {
        "WhyChooseheading": "On-Time Drop Guarantee",
        "WhyChoosedescription": "We understand the importance of time when traveling between Mumbai and Pune, especially for business or flight connections. Our trained drivers, smart route planning, and real-time traffic monitoring help ensure you're dropped off on schedule every time."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Suit Your Budget",
        "WhyChoosedescription": "Whether you’re traveling solo or in a group, we have the right vehicle for your trip. Choose from economical hatchbacks, mid-range sedans, or spacious SUVs—each offering the comfort and convenience of private travel without the cost of a round trip."
    }
]





































    }

// One Way Cab Services Mumbai to Pune Drop – eTravo

const faqData = [
    [
        {
            question: 'Does eTravo offer one-way cab service from Mumbai to Pune?',
            answer: 'Yes, eTravo provides convenient and reliable one-way cab services from Mumbai to Pune, perfect for business travelers, airport drops, or personal trips.',
        },
        {
            question: 'What types of cabs are available for the Mumbai to Pune route?',
            answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and premium cars — all well-maintained and driven by professional chauffeurs.',
        },
        {
            question: 'Is the pricing fixed for one-way Mumbai to Pune cab bookings?',
            answer: 'Yes, we provide transparent, fixed pricing for one-way drops from Mumbai to Pune, with no hidden charges. Toll and parking fees are either included or clearly mentioned upfront.',
        },
        {
            question: 'Can I book a cab for early morning or late-night drop to Pune?',
            answer: 'Absolutely. Our Mumbai to Pune drop service operates 24/7, so you can book a cab for any time — early morning, midnight, or peak hours — with on-time pickup guaranteed.',
        },
        {
            question: 'Is this service suitable for corporate travel or client transfers?',
            answer: 'Yes, our one-way drop service is ideal for corporate executives, employee relocations, and client pickups or drops. We also offer invoicing and trip records for your company’s records.',
        },
        {
            question: 'Can I schedule a one-way drop in advance?',
            answer: 'Yes, you can pre-book your Mumbai to Pune cab in advance through our app, website, or customer support. Advance bookings ensure guaranteed availability and preferred vehicle selection.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Anil Verma',
        designation: 'Sales Executive, Raxon Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a one-way drop from Mumbai to Pune with eTravo — the driver was punctual, the car was clean, and the entire journey was smooth. Highly recommended!”',
    },
    {
        name: 'Ms. Priya Shetty',
        designation: 'Frequent Business Traveller',
        rating: [1, 1, 1, 1, 1],
        text: '“I often travel between Mumbai and Pune for meetings. eTravo’s one-way cab service is affordable and dependable. They’ve become my go-to travel partner.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


   const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Services Mumbai to Pune Drop",
  "image": "https://www.etravo.in/images/keyword/one-way-cab-mumbai-pune.jpg",
  "description": "Book reliable one-way cab services from Mumbai to Pune with eTravo. Perfect for corporate travelers, executive drops, and business clients seeking affordable, safe, and AC-equipped taxi services.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1780"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/one-way-cab-services-mumbai-to-pune-drop"
  }
};







    return (
        <div>

<Helmet>
  <title>One Way Cab Services Mumbai to Pune Drop | Corporate & Executive Taxi | eTravo</title>
  <meta 
    name="description" 
    content="Hire one-way cab services from Mumbai to Pune with eTravo for corporate and executive travel. Affordable, safe, and comfortable AC cabs for business clients." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                                <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onewaycabservicemumbaitopunedrop;